import { skills } from "../data";
import SectionHeading from "./SectionHeading";

function TechStack() {
  return (
    <section className="section container" id="skills">
      <SectionHeading title="Tech Stack" />

      <div className="spec-grid">
        {skills.map((group, index) => (
          <article className={`spec-cell hover-${group.tone}`} key={group.category}>
            <span className="mono">{String(index + 1).padStart(2, "0")}</span>
            <h3>{group.category}</h3>
            <div className="skill-tags">
              {group.items.map((item) => (
                <span key={item}>{item}</span>
              ))}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default TechStack;
